import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpMethod } from "../../../common/api/http";
import { PageSizes } from "../../../common/constants";
import { EntityIdObject } from "../../../common/types";
import {
  CalcRecordFilterPageRequest,
  CalcRecordFilterPageResult,
  CalcRecordRequestResponse,
  CalcRecordStackTracesLogs,
  CalcRecordWebservicesLogs,
} from "./types";

const FILTER_CALC_RECORDS = ApiRequestAdapter.create("/calculators/records", HttpMethod.GET);
const GET_CALC_RECORD_REQUEST_RESPONSE = ApiRequestAdapter.create(
  "/calculators/records/{0}/request-response",
  HttpMethod.GET,
);
const GET_CALC_RECORD_WEBSERVICES_LOGS = ApiRequestAdapter.create(
  "/calculators/records/{0}/webservices-logs",
  HttpMethod.GET,
);
const GET_CALC_RECORD_STACK_TRACES_LOGS = ApiRequestAdapter.create(
  "/calculators/records/{0}/stack-traces-logs",
  HttpMethod.GET,
);

export const DEFAULT_FILTER_CALC_RECORDS_QUERY_PARAMS: Required<
  Omit<CalcRecordFilterPageRequest, "operationType" | "calcType">
> = {
  pageIndex: 0,
  pageSize: PageSizes.LARGE,
  keyword: "",
  createdAtMin: "",
  createdAtMax: "",
};

export const calcRecordsApi = {
  filterCalcRecords: (request: CalcRecordFilterPageRequest): AxiosPromise<CalcRecordFilterPageResult> => {
    return apiService.get(FILTER_CALC_RECORDS.url, { params: request });
  },
  getCalcRecordRequestResponse: <T extends CalcRecordRequestResponse = CalcRecordRequestResponse>(
    request: EntityIdObject,
  ): AxiosPromise<T> => {
    return apiService.get(GET_CALC_RECORD_REQUEST_RESPONSE.getParametrizedUrl(request.id));
  },
  getCalcRecordWebservicesLogs: (request: EntityIdObject): AxiosPromise<CalcRecordWebservicesLogs> => {
    return apiService.get(GET_CALC_RECORD_WEBSERVICES_LOGS.getParametrizedUrl(request.id));
  },
  getCalcRecordStackTracesLogs: (request: EntityIdObject): AxiosPromise<CalcRecordStackTracesLogs> => {
    return apiService.get(GET_CALC_RECORD_STACK_TRACES_LOGS.getParametrizedUrl(request.id));
  },
};
